import React from 'react';
import { TFunction } from 'i18next';
import { Variant } from '@/components/Ad/Status/PaymentFlow.types';
import { IconBox } from '@/components/UI/IconBox/IconBox.styles';

export const getVariants = ({
  t,
  minBundlePrice,
  minVipPrice,
  minFeaturedPrice,
  prevVipPrice,
  prevFeaturedPrice,
}: {
  t: TFunction;
  minBundlePrice: number;
  minVipPrice: number;
  minFeaturedPrice: number;
  prevVipPrice: number;
  prevFeaturedPrice: number;
}): Variant[] => [
  {
    id: 1,
    icon: <IconBox $filename="photos.svg" $iconWidth={18} $iconHeight={18} />,
    title: t('pages.ad.paid_placement'),
    price: minBundlePrice,
    type: 'bundle',
  },
  {
    id: 2,
    icon: <IconBox $filename="vip.svg" $iconWidth={22} $iconHeight={18} />,
    title: t('pages.ad.make_vip'),
    price: minVipPrice,
    type: 'vip',
    previousPrice: minVipPrice < prevVipPrice ? prevVipPrice : undefined,
  },
  {
    id: 3,
    icon: <IconBox $filename="crown.svg" $iconWidth={22} $iconHeight={18} />,
    title: t('pages.ad.make_premium'),
    price: minFeaturedPrice,
    type: 'featured',
    previousPrice:
      minFeaturedPrice < prevFeaturedPrice ? prevFeaturedPrice : undefined,
  },
];
